(function() {
    'use strict';

    angular.module('app')
        .controller('rootCtrl', rootCtrl);

    function rootCtrl($q, $location, $rootScope, $timeout, modalService, loginService,
        headerService, sysCode, translateService, $window, $scope, trainingInnerService, mobileService) {
        var vm = this;
        vm.view = {
            loaded: false, //檢查是否將必要資源讀取完畢
        };
        vm.getBodyClass = getBodyClass;
        vm.appVersion = null;
        vm.appCurrentVersion = null;
        vm.getDeviceInfo = getDeviceInfo;
        vm.updateConfirmWording = null;
        vm.conAppVer = null;
        vm.conCurVer = null;

        var mobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
            }
        };

        onInit();
        eventBus();

        function onInit() {
            var promiseList = [
                loadTranslate(),
                loadSsoInfo(),
            ];
            $q.all(promiseList).then(function() {
                vm.view.loaded = true;
            });

            //只在首頁判斷版本
            if (mobile.iOS() && (window.webkit)) {
                //if (true) {
                getDeviceInfo();
                //console.log('appVer:',APP_VERSION);
                //console.log('AppUpdateRemind:',sessionStorage.getItem('AppUpdateRemind'));
                if (!sessionStorage.getItem('AppUpdateRemind')) {
                    sessionStorage.setItem('AppUpdateRemind', 'N');
                }
                console.log('AppUpdateRemind:', sessionStorage.getItem('AppUpdateRemind'));
                if (sessionStorage.getItem('AppUpdateRemind') && sessionStorage.getItem('AppUpdateRemind') === 'N') {
                    //getDeviceInfo那邊設定3秒call 6 次，這邊改為5秒後再執行版本確認
                    setTimeout(function() {
                        checkAppVersion();
                    }, 5000);
                }
            }

            // 外網沒有這個需求 所以不用處理跨系統轉 token 這類事情
            // 也可以避免分享網址時 就在別人家的瀏覽器自動登入了
            // checkTokenFromOtherDomain();

            try {
                self.moveTo(0, 0);
                self.resizeTo(screen.availWidth, screen.availHeight);
            } catch (e) {
                // 不是重要的功能(失效也不會影響網站功能)
                // 在IE有時候不知道為什麼會造成錯誤，讓畫面無法繼續進行
                // 所以針對此問題先隱蔽
            }

            setUrl();
            setFontSize();
            $rootScope.styleUrl = '/css/edit.css';
            $rootScope.isTest = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            checkSmallView();
        }

        function loadTranslate() {
            return translateService.getTranslates().then(function(data) {
                //console.log(data.iosAppUpdateConfirm);
                vm.updateConfirmWording = data.iosAppUpdateConfirm;
                $rootScope.translate = data;
                return true;
            });
        }

        function loadSsoInfo() {

        }

        function checkSmallView() {
            if ($window.innerWidth < 470) {
                $rootScope.isSmallView = true;
            } else {
                $rootScope.isSmallView = false;
            }
        }

        function checkTokenFromOtherDomain() {
            //undone 跨token的部份
            var originUrl = location.href.split('?tkn=')[0];
            var urlSearch = location.href.split('?tkn=')[1];
            if (urlSearch) {
                var getToken = queryString('tkn');
                var getMenu = queryString('menu');
                var isMobile = queryString('isMobile');
                if (isMobile) {
                    // sessionStorage.setItem('isMobile', true);
                }
                if (getToken) {
                    // removeSsoInfo();
                    getToken = getToken === undefined ? sessionStorage.getItem('token') : getToken;
                    sessionStorage.setItem('token', getToken);
                    var params = {
                        token: getToken,
                        sysCode: sysCode
                    };
                    loginService.checkToken(params).then(function(data) {
                        removeSsoInfo();
                        if (data.data) {
                            data.data.Token = getToken;
                            setSsoInfo(data.data);
                            translateService.getLanguage().then(function(languageItems) {
                                var defaultLangItem = _.find(languageItems.data, {
                                    selected: true
                                });
                                translateService.change(defaultLangItem).then(function() {
                                    if (getMenu) {
                                        $window.location.href = originUrl + '?menu=' + getMenu;
                                    } else {
                                        $window.location.href = originUrl;
                                    }
                                });
                            });
                        }
                    });
                }
            } else {
                if (location.href.indexOf('&isMobile=') > -1) {
                    originUrl = location.href.split('?menu=')[0];
                    // sessionStorage.setItem('isMobile', queryString('isMobile'));
                    //2023-07-10 Johnson 資安2023
                    location.href = eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('3+\'?2=\'+4(\'2\').0(/</1,\'&5\').0(/>/1,\'&6\').0(/"/1,\'&7\').0(/\'/1,\'&#8\').0(/[<>!]|(\\(\\))|((9|a|b)\\c*\\(.*\\))/1,\'\')', 13, 13, 'replace|g|menu|originUrl|queryString|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}))
                }
                translateService.getLanguage().then(function(languageItems) {
                    var defaultLangItem = _.find(languageItems.data, {
                        selected: true
                    });
                    translateService.change(defaultLangItem);
                });
            }
        }

        function setUrl() {
            var checkList = {
                ctmsFileUrl: sessionStorage.getItem('ctmsFileUrl'),
                mhrFileUrl: sessionStorage.getItem('mhrFileUrl'),
                VcUrl: sessionStorage.getItem('VcUrl')
            };
            headerService.getUrlSetting().then(function(data) {
                _.forEach(checkList, function(checkItem, key) {
                    switch (key) {
                        case 'ctmsFileUrl':
                            sessionStorage.setItem('ctmsFileUrl', data.data.ctmsFileUrl);
                            break;
                        case 'mhrFileUrl':
                            sessionStorage.setItem('mhrFileUrl', data.data.mhrFileUrl);
                            break;
                        case 'VcUrl':
                            if(data.data.vcUrl.indexOf(location.protocol) == -1)
                            {
                                if(location.protocol == "https:")
                                    sessionStorage.setItem('VcUrl',  data.data.vcUrl.replace("http:",location.protocol));
                                else
                                    sessionStorage.setItem('VcUrl',  data.data.vcUrl.replace("https:",location.protocol));
                                    
                            }
                            else
                                sessionStorage.setItem('VcUrl', data.data.vcUrl);

                            break;
                        default:
                            checkItem = 'empty';
                            break;
                    }
                });
            });
            console.log(sessionStorage.getItem('VcUrl'))
        }

        function setFontSizeProcess(fontsize) {
            switch (fontsize) {
                case 14:
                    vm.fontSizeClass = 'small';
                    break;
                case 16:
                    vm.fontSizeClass = 'medium';
                    break;
                case 18:
                    vm.fontSizeClass = 'big';
                    break;
                default:
                    //use recursive to process default;
                    if (fontsize < 14) { setFontSizeProcess(14); } else if (fontsize > 14) { setFontSizeProcess(18); } else { setFontSizeProcess(14); }
                    break;
            }
        }

        function setFontSize() {
            $rootScope.$watch('fontSize', function(newValue) {
                if (newValue) {
                    if (_.isString(newValue)) {
                        newValue = newValue.replace('px', '');
                    }
                    newValue = parseInt(newValue);
                    if (!newValue) { newValue = 14; }
                    setFontSizeProcess(newValue);
                    getBodyClass();
                }
            });
        }

        function getBodyClass() {
            return {
                small: vm.fontSizeClass === 'small',
                medium: vm.fontSizeClass === 'medium',
                big: vm.fontSizeClass === 'big',
                cn: parseInt(sessionStorage.getItem('langCode')) === 2
            };
        }

        function eventBus() {
            $rootScope.$on('emitCName', function(e, value) {
                $rootScope.$broadcast('updateCName', value);
            });
            $(window).resize(function() {
                if ($scope.$$phase || $rootScope.$$phase) {
                    return;
                }
                $rootScope.$apply(function() {
                    checkSmallView();
                });
            });
        }

        function checkAppVersion() {
            console.log('checkAppVersion');
            //從DB撈取APP現行版本
            //APP_VERSION = '0.0.0.9';
            trainingInnerService.getConfigSetting()
                .then(function(configData) {
                    vm.appCurrentVersion = configData.data.appCurrentVersion;
                    if (vm.appCurrentVersion && APP_VERSION !== null) {
                        console.log('APP_VERSION:', APP_VERSION);
                        var currentVer = parseInt(vm.appCurrentVersion.replace(/\./g, ''));
                        //var appVer = APP_VERSION ? parseInt(APP_VERSION.replace(/\./g, '')) : -1;

                        // 因與iosApp互動時，有可能無法抓到版本，目前改為iosAppVer的預設值為-1
                        // 如是舊版APP，版本就會是-1
                        // 如是新版APP，版本就會有寫入
                        // 唯一例外只有版本號不見時，但不確定會不會被改為Null，待測
                        var appVer = null;
                        if (Object.is(APP_VERSION, -1)) {
                            appVer = -1;
                        } else {
                            appVer = parseInt(APP_VERSION.replace(/\./g, ''));
                        }

                        vm.conAppVer = appVer;
                        vm.conCurVer = currentVer;

                        if (appVer === currentVer) {
                            //vm.appVersion = APP_VERSION;
                        } else if (appVer > currentVer) {
                            alert('You are using iTaishin beta version.');
                        } else {
                            // $timeout(function() {
                            //     var confirmDialog = modalService.confrimDialog({
                            //         confirmContent: (vm.updateConfirmWording),
                            //     });
                            //     confirmDialog.result.then(function(result) {
                            //         result = !!result;
                            //         if (result !== true) {
                            //             return;
                            //         }
                            //         location.href = 'itms-services://?action=download-manifest&url=https://hr.taishinholdings.com.tw/hr-app-download/appfiles/manifest.plist';
                            //     });
                            // }, 1000);
                        }
                        //辨識用的flag，讓confirm只出現一次
                        sessionStorage.setItem('AppUpdateRemind', 'Y');
                    }
                });
        }

        function getDeviceInfo() {
            var param = {
                Command: 'getDeviceInfo'
            };
            ///vm.appVersion = APP_VERSION;

            //每500毫秒就叫一次ios傳值給我
            for (let i = 0; i < 6; i++) {
                var temp = i;
                setTimeout(function() {
                    //console.log(i);
                    window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(param));
                }, 500 * (i + 1));
            }
        }
    }
})();